import { deviceMasterData } from "../actionTypes"

// The Device Master page's unsaved work. Persisted, so edits not yet saved
// (or whose save failed) survive a reload.
const initialState = {
    // deviceId -> { deviceType?, toBeScheduled? }: only fields that differ from
    // what the service reported.
    edits: {}
}

export const deviceMasterReducer = (state = initialState, action) => {
    const { type, payload } = action
    switch (type) {
        case deviceMasterData.MERGE:
            return { ...state, ...payload }
        default:
            return state
    }
}
